import React, { useState, useEffect } from "react";
import { db } from "../../src/firebase";
import { collection, getDocs, query, where, deleteDoc, doc } from "firebase/firestore";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TablePagination,
} from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const AdminMovies = () => {
  const [movies, setMovies] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMovies = async () => {
      try {
        const moviesCollection = collection(db, "movies");
        const moviesQuery = query(moviesCollection, where("publish", "==", "1"));
        const moviesSnapshot = await getDocs(moviesQuery);
        const moviesList = moviesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMovies(moviesList);
      } catch (error) {
        console.error("Error fetching movies:", error);
      }
    };

    fetchMovies();
  }, []);

  const deleteMovie = async (id) => {
    try {
      await deleteDoc(doc(db, "movies", id));
      setMovies(movies.filter((movie) => movie.id !== id));
    } catch (error) {
      console.error("Error deleting movie:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
    
      <Typography variant="h4" sx={{ marginBottom: 2 }}>
      Manage Movies
            </Typography>

      {/* Add Movie Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/add-movie")}
        sx={{ marginBottom: 2 }}
      >
        Add Movie
      </Button>

      <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
        <Table >
        <TableHead sx={{ backgroundColor: "#7d1aed" }}>
            <TableRow>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>S. No</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Title</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Genre</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Director</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Duration (mins)</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Cast</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Crew</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Target Funding</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Unit Price</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Created At</TableCell>
               <TableCell sx={{ color: "white", fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {movies.length > 0 ? (
              movies
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((movie,index) => (
                  <TableRow key={movie.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{movie.title}</TableCell>
                    <TableCell>{movie.genre}</TableCell>
                    <TableCell>{movie.director}</TableCell>
                    <TableCell>{movie.duration}</TableCell>
                    <TableCell>{movie.cast ? movie.cast.join(", ") : "N/A"}</TableCell>
                    <TableCell>{movie.crew ? movie.crew.join(", ") : "N/A"}</TableCell>
                    <TableCell>${movie.targetFunding.toLocaleString()}</TableCell>
                    <TableCell>{movie.unitPrice === -1 ? "Not Available" : `$${movie.unitPrice}`}</TableCell>
                    <TableCell>
                      {movie.createdAt
                        ? moment(movie.createdAt.toDate()).format("YYYY-MM-DD HH:mm")
                        : "N/A"}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ marginRight: 1 }}
                        onClick={() => navigate(`/edit/${movie.id}`)}
                      >
                        Edit
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => deleteMovie(movie.id)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  No movies found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 20]}
        component="div"
        count={movies.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default AdminMovies;
